import { render, staticRenderFns } from "./PublicSocialLogin.vue?vue&type=template&id=596f0745"
import script from "./PublicSocialLogin.vue?vue&type=script&lang=ts"
export * from "./PublicSocialLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports